// client-side-validations and simple_form only style errors; tie each message
// to its field and focus the first error when a submit is rejected.
const describeError = (field) => {
  const error = field.parentElement.querySelector('.invalid-feedback')
  if (!error) return
  error.id ||= `${field.id}_error`
  field.setAttribute('aria-describedby', error.id)
}

const focusFirstError = (form) => {
  const field = form.querySelector('[aria-invalid="true"]')
  if (!field) return
  const select2 = field.nextElementSibling?.querySelector('.select2-selection')
  const target = select2 || field
  target.focus()
}

const { callbacks } = window.ClientSideValidations

callbacks.element.fail = (element, message, addError) => {
  addError()
  element.setAttribute('aria-invalid', 'true')
  describeError(element)
}

callbacks.element.pass = (element, removeError) => {
  removeError()
  element.removeAttribute('aria-invalid')
  element.removeAttribute('aria-describedby')
}

// Capture phase plus a timeout: client-side-validations stops propagation of
// the submits it blocks, so this is the only way to see them afterwards.
document.addEventListener(
  'submit',
  (event) => {
    setTimeout(() => {
      if (event.defaultPrevented) focusFirstError(event.target)
    })
  },
  true
)

// Server-rendered errors, e.g. sign-up, where invisible reCAPTCHA submits via
// form.submit() and so bypasses client-side validation.
document.addEventListener('DOMContentLoaded', () => {
  const fields = document.querySelectorAll('[aria-invalid="true"]')
  fields.forEach(describeError)
  if (fields[0]?.form) focusFirstError(fields[0].form)
})
